import {requestCore,requestCommon,requestInfo} from '@/libs/axios'


export const sendCode = (params,header={}) => requestCore.post('/common/message/sendSms', params,header) // 发送验证码
export const getConfig = (params) => requestCore.post('/common/client/config', params) // 获取配置
/*获取系统参数*/
export const getCommonConfigKey = (data) =>
    requestCore.post("/common/config/key", data)

    // lawsuitShare.7.0
/* 获取当前用户有效的案源信息*/
export const caseSourceV2GetInfo = (data) =>
requestInfo.post('/caseSourceV2/getInfo', data)

/* 案源保存*/
export const caseSourceV2Save = (data) =>
requestInfo.post('/caseSourceV2/save', data)

/* 案源创建*/
export const createOrder = (data) =>
requestCommon.post('/order/v2/orderUser/createOrder', data)

/* 支付v2*/
export const orderPay = (data) =>
requestCommon.post('/order/v2/orderUser/pay', data)

/* 数据字典*/
export const dataDictionary = (data) => requestCore.post('/dataDetail/list', data)

/* 订单状态查询v2*/
export const queryOrderStatus = (data) =>
requestCommon.post('/order/v2/orderUser/queryOrderStatus', data)

/* 用户订单列表v2*/
export const ordersList = (data) =>
requestCommon.post('/order/v2/orderUser/orders', data)

/* 根据服务code 获取服务价格相关信息*/
export const serviceManegeInfo = (serverCode) =>
requestCommon.post(`/info/serviceManege/info/${serverCode}`)


/* 用户信息*/
export const paralegalUserInfo = (data) =>
    requestCommon.post('/paralegal/user/info', data)


/* 获取客户端配置*/
export const getCommonClientConfig = (data) =>
    requestCommon.post('/core/common/client/config', data)

/* 律师详情*/
export const oneLawyer = (data) => requestCommon.post('/lawyer/lawyer/oneLawyer', data)

/* 获取用户和律师的服务信息和IM信息*/
export const getServerAndImInfo = (data) => requestCommon.post('/info/caseSourceServerV2/getServerAndImInfo', data)

/* 快速咨询用户购买服务滚动信息 2.lawsuitShare.0*/
export const fastConsultBuyUsers = (data) => requestInfo.post('/lawyer/fastConsult/buyUsers', data)

/* 2.lawsuitShare.3获取公共服务律师*/
export const getCommonLawyer  = () =>
  requestCommon.post('/lawyer/getCommon/lawyer')